import { z } from "zod";

export const portalConfigurationSchema = z.object({
  vendorProfileId: z.string(),
  type: z.string(),
  jsonDefinition: z.object({
    config: z.record(z.unknown()),
  }),
});
